import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, ModelState, ShowModelPayload } from '../lib/types'

const confirmModelSlice = createSlice({
  name: 'confirmModel',
  initialState: {
    name: '',
    isShow: false,
    isConfirm: false,
    message: '',
  },
  reducers: {
    showModel: (state: ModelState, action: PayloadAction<ShowModelPayload>) => {
      state.isShow = true
      state.isConfirm = false
      state.message = action.payload.message
      state.name = action.payload.name
    },
    hideModel: (state: ModelState) => {
      state.isShow = false
      state.isConfirm = false
      state.message = ''
      state.name = ''
    },
    confirmActionModel: (state: ModelState) => {
      state.isConfirm = true
      state.isShow = false
    },
  },
})
export const showModelTimeout = () => (dispatch: AppDispatch) => {
  setTimeout(() => {
    dispatch(hideModel())
  }, 1000)
}

export { confirmModelSlice }
export const { showModel, hideModel, confirmActionModel } = confirmModelSlice.actions

export default confirmModelSlice.reducer
